import { storageKey, defaultLocale } from '../constants';
import setSelectedLocale from './setSelectedLocale';

const getSelectedLocale = () => {
  let selectedLocale = localStorage.getItem(storageKey);

  if (!selectedLocale) {
    selectedLocale = defaultLocale;
    setSelectedLocale(selectedLocale);
  }

  return selectedLocale;
};

export default getSelectedLocale;
